import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Button, { ButtonVariations } from '../../../SolvPatternLibrary/Button';
import { isBookable } from '../../../../core/util/location';
import { analyticsTrackEvent } from '../../../../core/analytics/index';
import { colors } from '../../../../constants/colors';
import { fontSize } from '../../../../constants/text';
import {
  CDP_TOUCH_FIND_NEARBY_CLINICS,
  CDP_TOUCH_PRIMARY_ACTION,
} from '../../../../core/analytics/events';
import { BOOKING_TIME_SELECTOR_MODAL } from '../components/BookModule/Modal';
import { CDP_CLICK_TO_CALL_MODAL } from '../components/ClickToCall';

export const NEARBY_ANCHOR_ID = 'nearby-anchor';

const Root = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  -webkit-font-smoothing: antialiased;
`;

const MainCTA = styled(Button)`
  width: 100%;
  max-width: 600px;
  margin: auto;
  height: 44px;
  font-size: ${fontSize.default};
  box-shadow: none;
  padding: 0;
`;

const NearbyButton = styled(MainCTA)`
  margin-top: 10px;
  border: ${colors.crunchBerry} 1px solid;
  color: ${colors.crunchBerry};
  background-color: unset;

  &:hover {
    background-color: unset;
  }
`;

const BOOK_ONLINE = 'Book Online';
const CALL_CLINIC = 'Call for Visit';

const CallIcon = styled.img`
  width: ${fontSize.mediumSmall};
  height: ${fontSize.mediumSmall};
  display: inline;
  padding: 0 9px 0 0;
  transform: translateY(-2px);
`;

export default class Book extends PureComponent {
  static propTypes = {
    location: PropTypes.object.isRequired,
    showModal: PropTypes.func.isRequired,
    className: PropTypes.string,
  };

  getCTAText = () => (isBookable(this.props.location) ? BOOK_ONLINE : CALL_CLINIC);

  ctaActions = {
    [BOOK_ONLINE]: () => this.props.showModal(BOOKING_TIME_SELECTOR_MODAL),
    [CALL_CLINIC]: () => this.props.showModal(CDP_CLICK_TO_CALL_MODAL),
  };

  handleNearbyClick = () => {
    const { id, uclId } = this.props.location;
    analyticsTrackEvent(CDP_TOUCH_FIND_NEARBY_CLINICS, {
      locationId: id,
      uclId,
    });
    document
      .getElementById(NEARBY_ANCHOR_ID)
      .scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  handleClickBook = () => {
    const { id, uclId } = this.props.location;
    const trackingProperties = {
      action: this.getCTAText(),
      locationId: id,
      uclId,
    };

    analyticsTrackEvent(CDP_TOUCH_PRIMARY_ACTION, trackingProperties);
    this.ctaActions[this.getCTAText()]();
  };

  render = () => {
    const { location, className } = this.props;
    const showNearby = !isBookable(location);
    return (
      <Root className={className}>
        <MainCTA
          variation={ButtonVariations.pinkPrimarySmall}
          onClick={this.handleClickBook}
          data-testid="mobileBookBtn"
        >
          {showNearby && <CallIcon src="/images/icons/Icon-Phone.svg" alt="Call icon" />}
          {this.getCTAText()}
        </MainCTA>
        {showNearby && (
          <NearbyButton
            variation={ButtonVariations.pinkPrimarySmall}
            onClick={this.handleNearbyClick}
          >
            Find Nearby Clinics
          </NearbyButton>
        )}
      </Root>
    );
  };
}
